import { Autocomplete, Box, Paper, Skeleton, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { ImageSize, LogoSize } from '#enums/imageSizes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { Image } from './styled.ts';
import { type ComponentProps } from './types.ts';

export const Component = ({ ariaLabelledBy, name, options, setFieldValue, setInputValue, value }: ComponentProps) => {
  const theme = useTheme();
  const { config } = useToolbelt();
  // Tricking getOptionLabel to accept a JSX element as a label
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const skeleton = (<Skeleton sx={{ fontSize: '0.8125rem' }} variant="text" width={80} />) as unknown as string;

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name || skeleton}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        onInputChange={(_e, newInputValue) => {
          setInputValue(newInputValue);
        }}
        options={options}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, companyOpts) => (
          <Box component="li" {...props} key={companyOpts.id}>
            <Image
              alt={name}
              loading="lazy"
              src={buildImagePath(companyOpts.logoPath, ImageSize.Logo, LogoSize.SM, config.images)}
            />
            {companyOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
